export class Mitarbeiter {
  constructor({
    id,
    vorname,
    nachname,
    imgUrl,
  }: {
    id: string;
    vorname: string;
    nachname: string;
    imgUrl?: string;
  }) {
    this.id = id;
    this.vorname = vorname;
    this.nachname = nachname;
    this.imgUrl = imgUrl;
  }

  id: string;
  vorname: string;
  nachname: string;
  imgUrl?: string;
}
